import type { Report } from "../types";
import { formatNumber, formatTimestamp } from "../lib/format";

export function MarketContext({ report }: { report: Report }) {
  return (
    <div className="market-context-grid">
      {report.platforms.map((platform) => <span className="market-context-chip market-context-chip-brand" key={`${platform.name}-${platform.marketId ?? "platform"}`}>{platform.name}</span>)}
      <span className="market-context-chip">{report.state}</span>
      {report.marketVolume !== null && report.marketVolume !== undefined ? <span className="market-context-chip">Volume {formatNumber(report.marketVolume)}</span> : null}
      {report.marketLiquidity !== null && report.marketLiquidity !== undefined ? <span className="market-context-chip">Liquidity {formatNumber(report.marketLiquidity)}</span> : null}
      {report.resolutionDate ? <span className="market-context-chip">Resolves {formatTimestamp(report.resolutionDate)}</span> : null}
    </div>
  );
}
